import React from 'react';
import { useTranslation } from 'react-i18next';
import { services } from './ServicesDataBenefits';
import { FeaturesSectionWithCardGradient } from '../../ui/feature-section-with-card-gradient';
import './../../../styles/tailwind-custom.css';

const BenefitsPrivateCloud = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen w-full dark">
      <div className="absolute top-0 left-0 w-full">
        <FeaturesSectionWithCardGradient 
          services={services.map((service, index) => ({
            ...service,
            title: t(`appCloud.benefits.services.${index}.title`, service.title),
            description: t(`appCloud.benefits.services.${index}.description`, service.description),
          }))}
          title=""
        />
      </div>
    </div>
  );
};

export default BenefitsPrivateCloud;